var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"domains-container"},[_c('h2',{staticClass:"section-title"},[_vm._v("Arii de Expertiza")]),_c('div',{staticClass:"cards"},_vm._l((_vm.domains),function(domain,index){return _c('div',{key:index,staticClass:"card-item"},[_c('domain-card',{attrs:{"domain":domain}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }